import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Helmet from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import forEach from 'lodash/forEach';
import get from 'lodash/get';
import Layout from 'yoda-site-components/lib/components/Layout/Layout';
import CertonaZone from 'yoda-site-components/lib/components/CertonaZone/CertonaZone';
import {
    ANALYTICS_ACTIONS_COUPON_APPLIED_SUCCESS,
    ANALYTICS_ACTIONS_MOVE_TO_CART,
    ANALYTICS_SUB_TOTAL,
    ANALYTICS_ACTIONS_SELECT_STORE_SUCCESS,
    ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL,
    GOOGLE_ADS_CART_PAGE_BOTTOM_LEFT,
    PAGE_TITLES_CART,
} from 'yoda-checkout-components/lib/common/Constants';
import classnames from 'classnames/bind';
import Cookies from 'yoda-core-components/lib/helpers/Cookies/Cookies';
import LocalStorage from 'yoda-core-components/lib/helpers/LocalStorage/LocalStorage';
import ModalBox from 'yoda-core-components/lib/components/ModalBox/ModalBox';
import PageBanners from 'yoda-checkout-components/lib/components/PageBanners/PageBanners';
import Canonincalize from 'yoda-account-components/lib/components/Canonincalize/Canonincalize';
import TokenProvider from 'yoda-core-components/lib/helpers/TokenProvider/TokenProvider';
import AccessTokenProviderAction from 'yoda-site-components/lib/actions/AccessTokenProviderAction';
import itemActions from 'yoda-site-components/lib/actions/ItemCountAction';
import {
    setGlobalErrorHandler,
    updateUserZipcodeBasedSTHItem,
    getCartEventData,
} from 'yoda-checkout-components/lib/helpers/Utils/Utils';
import { scrollToElement } from 'yoda-checkout-components/lib/helpers/Utils/ATCCommonUtils';
import { setLastCartVisitTime } from 'yoda-site-components/lib/helpers/Utils/activeCartLastCartVisitTime';
import orderActions from 'yoda-site-components/lib/actions/OrderAction';
import * as CheckoutAnalyticsAction from 'yoda-checkout-components/lib/actions/CheckoutAnalyticsAction';
import * as nativeAppAction from 'yoda-site-components/lib/actions/NativeAppAction';
import splunkLogsActions from 'yoda-checkout-components/lib/actions/SplunkLogsActions';
import CartItemPreShellLoader from 'yoda-checkout-components/lib/components/PreShellLoaders/CartItemPreShellLoader/CartItemPreShellLoader';
import GenericOopsMessage from 'yoda-checkout-components/lib/components/GenericOopsMessage/GenericOopsMessage';
import withBoundaryError from 'yoda-checkout-components/lib/components/ErrorBoundary/ErrorBoundaryHOC';
import { ATCInterstitialContextProvider } from 'yoda-checkout-components/lib/contexts/ATCInterstitialContext';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import * as cartDetailsAction from '../../../actions/GetCartDetailsAction';
import { SavedItemsList as SavedItemsLazy, SavedItemsList } from './LazyModules/SavedItemsLazy';
import { updateAnalyticsClickAction } from '../../../actions/updateAnalyticsClickAction';
import CartPageWrapper from './CartPageWrapper/CartPageWrapper';
import { cartPageMsg } from '../../../common/LabelConstants';
import {
    SessionTimeoutModal as CartPageModalsLazy,
    SessionTimeoutModal,
    SerialCodeInputModal,
    CouponsPanel,
    ShowRewardsPanel,
} from './LazyModules/CartPageModalsLazy';
import styles from './CartPage.css';

const cx = classnames.bind(styles);
let isAnalyticsPageLoadTriggered = false;
let isAbandonedCartPushEventTriggered = false;
const section = 'CART';

export const PRODUCT_CARTRIDGE_ATTRIBUTES_EMPTYCART = {
    pagetype: 'EMPTYCART',
    slotTypeOne: 'emptycart1',
    slotTypeTwo: 'emptycart2',
    slotIdOne: 'emptycart1_rr',
    slotIdTwo: 'emptycart2_rr',
    automationIdOne: 'emptycart-product-cartridge-one',
    automationIdTwo: 'emptycart-product-cartridge-two',
};
export const PRODUCT_CARTRIDGE_ATTRIBUTES_CART = {
    pagetype: 'CART',
    slotTypeOne: 'cart1',
    slotTypeTwo: 'cart2',
    slotIdOne: 'cart1_rr',
    slotIdTwo: 'cart2_rr',
    automationIdOne: 'cart-product-cartridge-one',
    automationIdTwo: 'cart-product-cartridge-two',
};
export class CartPage extends PureComponent {
    static propTypes = {
        certonaAttributes: PropTypes.objectOf(PropTypes.any),
        cartDetails: PropTypes.objectOf(PropTypes.object),
        analyticsClickEvent: PropTypes.string,
        actions: PropTypes.objectOf(PropTypes.func),
        loadEmptyCart: PropTypes.bool,
        noPartsAndService: PropTypes.bool,
        deviceType: PropTypes.objectOf(PropTypes.object),
        sflActionStatus: PropTypes.bool,
        selectedStore: PropTypes.objectOf(PropTypes.any),
        isSessionTimedOut: PropTypes.bool,
        tokenInfo: PropTypes.objectOf(PropTypes.string),
        featureFlags: PropTypes.objectOf(PropTypes.object),
        preferences: PropTypes.objectOf(PropTypes.object),
        orderInfo: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
        orderTotals: PropTypes.objectOf(PropTypes.string),
        headers: PropTypes.objectOf(PropTypes.object),
        showBlurBG: PropTypes.bool,
        isNative: PropTypes.bool,
        location: PropTypes.objectOf(PropTypes.any),
    };

    static defaultProps = {
        certonaAttributes: {},
        cartDetails: {},
        actions: {},
        loadEmptyCart: false,
        analyticsClickEvent: '',
        deviceType: {},
        sflActionStatus: false,
        selectedStore: {},
        isSessionTimedOut: false,
        tokenInfo: {},
        featureFlags: {},
        preferences: {},
        orderInfo: {},
        orderTotals: {},
        headers: {},
        noPartsAndService: false,
        showBlurBG: false,
        isNative: false,
        location: {},
    };

    constructor() {
        super();
        this.errorSubscription = () => {};
        this.pageBlockRef = React.createRef();

        // To clean up localstorage failure case
        LocalStorage.removeData('orderIdNumber');
        LocalStorage.removeData('orderUserName');
        LocalStorage.removeData('orderUserEmail');
        LocalStorage.removeData('bnplSelected');
        this.state = {
            mainContainerHeightOverride: null,
        };
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillMount() {
        if (!__SERVER__) {
            window.jcpDLjcp = {}; // Added this object initialization to allow ensighten team to fix the issue.
            /* istanbul ignore next */
            if (window.Modernizr) {
                // Hack to prevent error thrown when prefixed fn is called from 3rd party modules
                window.Modernizr.prefixed = () => false;
            }
        }
    }

    /**
     * This is temp fix only for desktop, we need to hide the change store link as it is not working due to compatibility issues.
     * Please dont remove this code.
     */
    componentDidMount() {
        // Saving cartId to localStorage for debugging purposes. Since there are no cookies in micro services,
        // if the order doesn't load there is no way to get the cart Id hence saving in localStorage.
        LocalStorage.setData('cartId', this.props.orderInfo.id, true);
        LocalStorage.setData('ItemCount', this.props.orderInfo.itemsCount, true);

        const { splunkLogs } = this.props.featureFlags;

        if (splunkLogs) {
            /* istanbul ignore else */
            if (splunkLogs.enableBootstrapLoaded) {
                /* istanbul ignore next */
                window.addEventListener('beforeunload', () => {
                    try {
                        /* istanbul ignore next */
                        const bootStrapLoaded = !isEmpty(window.Bootstrapper);
                        this.props.actions.logInSplunk({
                            name: 'CART PAGE LOG',
                            value: `BOOT STRAP LOADED: ${bootStrapLoaded}`,
                            orderId: this.props.orderInfo.id,
                        });
                    } catch (error) /* istanbul ignore next */ {
                        console.log(error);
                    }
                });
            }

            /* istanbul ignore next */
            if (splunkLogs.enableGlobalErrorLogs) {
                this.errorSubscription = setGlobalErrorHandler(
                    section,
                    this.props.actions.logGlobalError
                );
            }
        }
        const storeLocator = document.getElementsByClassName('globalHeader_storeLocator');
        /* istanbul ignore if */
        if (get(storeLocator, '[0].style')) {
            storeLocator[0].style.display = 'none';
        }
        if (!isEmpty(this.props.tokenInfo)) {
            /** MCYODA-30956 remove AccessTOken from LS and Cookie
             *  initator of props.tokenInfo should not send Access_token and Refresh_token
             *  it can have other values like DP_USER_STATE, ACCOUNT_ID
             * storeTokenFromServer method will exclude Access_token and Refresh_token
             */
            TokenProvider.storeTokenFromServer(this.props.tokenInfo);
            AccessTokenProviderAction.clearTokenInfo();
        }
        // DA => Save cart total to local storage
        const daCartTotal =
            (this.props.orderTotals && this.props.orderTotals[ANALYTICS_SUB_TOTAL]) || 0;
        LocalStorage.setData(ANALYTICS_LOCAL_STORAGE_KEY_CART_TOTAL, daCartTotal);
        // DA ==> trigger pageLoad even for Empty CART
        if (
            (!isEmpty(this.props.cartDetails) || this.props.loadEmptyCart) &&
            !isAnalyticsPageLoadTriggered
        ) {
            const itemsCount = get(this.props, 'orderInfo.itemsCount', 0);
            Cookies.save('ItemCount', itemsCount, undefined, undefined, false);
            this.props.actions.updateItemCountAction(itemsCount);
            this.props.actions.pageLoadSuccessAnalyticsAction('cart');
            isAnalyticsPageLoadTriggered = true;
        }

        // Populate the selectedStore for desktop breakpoints
        // This scenario will happen when draft order is called as part of SSR
        /* istanbul ignore else */
        if (isEmpty(get(this.props, 'selectedStore.storeDetails'))) {
            let storeIdPayload = null;
            if (!isEmpty(this.props.orderInfo)) {
                storeIdPayload = { storeId: this.props.orderInfo.checkedStoreId };
            }
            this.props.actions.getStoreByStoreId(storeIdPayload);
        }
        this.deleteBlackListedCookies();
        this.props.orderInfo.id &&
            this.props.featureFlags.splunkLogs &&
            this.props.featureFlags.splunkLogs.enableCartPageLoaded &&
            this.props.actions.logInSplunk({
                name: 'CART PAGE LOG',
                value: 'CART PAGE LOADED',
                orderId: this.props.orderInfo.id,
            });
        /** MCYODA-30956 remove AccessTOken from LS and Cookie
         * setAccessToken method will exclude Access_token and Refresh_token and persist ACCOUNT_ID
         */
        TokenProvider.setAccessToken();
        TokenProvider.set('checkoutPrevUrl', '');
        /**
         * To add or update cookie 'DP_USER_DEFAULT_ADDRESS_ZIP' value based on order.
         */
        const enableSingleDeliveryDateSTH = get(
            this.props.featureFlags,
            'enableSingleDeliveryDateSTH',
            true
        );
        enableSingleDeliveryDateSTH && updateUserZipcodeBasedSTHItem(this.props.cartDetails);
        SavedItemsLazy.preload();
        CartPageModalsLazy.preload();
        window.addEventListener(
            'unload',
            /* istanbul ignore next */
            () => {
                setLastCartVisitTime();
            }
        );
    }

    // eslint-disable-next-line camelcase
    UNSAFE_componentWillReceiveProps(nextProps) {
        const { selectedStore, orderInfo = {}, actions } = this.props;
        // Populate the selectedStore for desktop breakpoints
        // This scenario will happen when draft order is called as part of client side rendering
        if (
            (isEmpty(selectedStore) || isEmpty(selectedStore.storeDetails)) &&
            !isEmpty(nextProps.orderInfo) &&
            orderInfo.checkedStoreId !== nextProps.orderInfo.checkedStoreId
        ) {
            actions.getStoreByStoreId({ storeId: nextProps.orderInfo.checkedStoreId });
        }
    }

    componentDidUpdate(prevProps) {
        const { cartDetails, sflActionStatus, selectedStore, loadEmptyCart, isNative } = this.props;
        // DA ==> trigger pageLoad even for Empty CART
        /* istanbul ignore next */
        if ((!isEmpty(cartDetails) || loadEmptyCart) && !isAnalyticsPageLoadTriggered) {
            this.props.actions.pageLoadSuccessAnalyticsAction('cart');
            isAnalyticsPageLoadTriggered = true;
        }
        /* istanbul ignore if */
        if (!isEmpty(cartDetails) && isNative && !isAbandonedCartPushEventTriggered) {
            const cartItemsData = getCartEventData(cartDetails?.data?.bag?.items);
            this.props.actions.updateCartCount(cartDetails?.data?.bag?.itemCount, cartItemsData);
            isAbandonedCartPushEventTriggered = true;
        }
        if (
            !isEmpty(cartDetails) &&
            !isEmpty(prevProps.cartDetails) &&
            !isEqual(cartDetails.data, prevProps.cartDetails.data)
        ) {
            LocalStorage.removeData('TOTAL_EXCEEDED_ERROR', true);
        }
        const prevIsMoveToCartSuccess = get(prevProps, 'sflActionStatus.isMoveToCartSuccess');
        const currentMoveToCartSuccess = get(sflActionStatus, 'isMoveToCartSuccess');
        if (
            currentMoveToCartSuccess &&
            !isEqual(currentMoveToCartSuccess, prevIsMoveToCartSuccess)
        ) {
            scrollToElement();
            const stickyInner = document.getElementsByClassName('sticky-inner-wrapper');
            const stickyInnerPosition = get(stickyInner, 'style.position');
            if (stickyInnerPosition) {
                stickyInner.style.position = 'relative';
            }
        }
        if (!isEmpty(this.props.analyticsClickEvent)) {
            this.props.actions.putAnalyticsClickEventStack(this.props.analyticsClickEvent);
            switch (this.props.analyticsClickEvent) {
                case ANALYTICS_ACTIONS_SELECT_STORE_SUCCESS:
                    if (!isEqual(selectedStore, prevProps.selectedStore)) {
                        this.props.actions.clickEventAnalyticsAction(
                            this.props.analyticsClickEvent
                        );
                        // Flush previously stored analytics action from store
                        this.props.actions.updateAnalyticsClickAction({});
                    }
                    break;
                case ANALYTICS_ACTIONS_COUPON_APPLIED_SUCCESS:
                    // Coupon applied must be fired only after getCart happens and gets the new adjustments
                    if (
                        !isEqual(
                            cartDetails.data.adjustments,
                            prevProps.cartDetails.data.adjustments
                        )
                    ) {
                        this.props.actions.clickEventAnalyticsAction(
                            this.props.analyticsClickEvent
                        );
                        // Flush previously stored analytics action from store
                        this.props.actions.updateAnalyticsClickAction({});
                    }
                    break;

                case ANALYTICS_ACTIONS_MOVE_TO_CART:
                    if (
                        cartDetails.data &&
                        cartDetails.data.bag &&
                        prevProps.cartDetails.data &&
                        prevProps.cartDetails.data.bag &&
                        !isEqual(cartDetails.data.bag.items, prevProps.cartDetails.data.bag.items)
                    ) {
                        this.props.actions.clickEventAnalyticsAction(
                            this.props.analyticsClickEvent
                        );
                        // Flush previously stored analytics action from store
                        this.props.actions.updateAnalyticsClickAction({});
                    }
                    break;
                default:
                    this.props.actions.clickEventAnalyticsAction(this.props.analyticsClickEvent);
                    // Flush previously stored analytics action from store
                    this.props.actions.updateAnalyticsClickAction({});
                    break;
            }
        }
        const shoppingQuantity = document.getElementById('orderQuantity');
        /* istanbul ignore if */
        if (this.props.orderInfo !== prevProps.orderInfo) {
            if (shoppingQuantity) {
                const { itemsCount } = this.props.orderInfo;
                /* MCYODA-20278 => Pass 5th param as false to make it non-secured */
                Cookies.save('ItemCount', itemsCount, undefined, undefined, false);
                shoppingQuantity.innerText = itemsCount;
            }
            const enableCartPageLoadedSplunkLog = get(
                this.props.featureFlags,
                'splunkLogs.enableCartPageLoaded'
            );
            if (
                prevProps.orderInfo.id === undefined &&
                this.props.orderInfo.id !== undefined &&
                enableCartPageLoadedSplunkLog
            ) {
                this.props.actions.logInSplunk({
                    name: 'CART PAGE LOG',
                    value: 'CART PAGE LOADED',
                    orderId: this.props.orderInfo.id,
                });
            }
        }
    }

    componentWillUnmount() {
        this.errorSubscription();
    }

    evaluateMainContainerHeight = (orderSummaryHeight) => {
        if (orderSummaryHeight >= this.pageBlockRef.current?.clientHeight) {
            this.state.mainContainerHeightOverride !== orderSummaryHeight &&
                this.setState({ mainContainerHeightOverride: orderSummaryHeight });
        } else {
            this.state.mainContainerHeightOverride !== null &&
                this.setState({ mainContainerHeightOverride: null });
        }
    };

    deleteBlackListedCookies() {
        if (__SERVER__) {
            return;
        }
        const blackListedCookies = this.props.preferences.blackListedCookies || [];
        forEach(blackListedCookies, (blackListedCookie) => {
            if (!blackListedCookie.required) {
                Cookies.remove(blackListedCookie.key);
            }
        });
    }

    renderProductCartridge() {
        const {
            certonaAttributes,
            featureFlags: { enableCartCertonaZone = true },
        } = this.props;
        /* istanbul ignore else */
        if (isEmpty(certonaAttributes) || !enableCartCertonaZone) {
            return null;
        }

        const productCartridgeAttribute = isEmpty(certonaAttributes.itemid)
            ? PRODUCT_CARTRIDGE_ATTRIBUTES_EMPTYCART
            : PRODUCT_CARTRIDGE_ATTRIBUTES_CART;

        let prodCatridgeClassName = `${cx(
            'lg12',
            'xl12',
            'prodCartridgeWrapper',
            'blockWithoutCart'
        )} ${dt(['sm:!p-0', '!block'])}`;
        if (productCartridgeAttribute === PRODUCT_CARTRIDGE_ATTRIBUTES_CART) {
            prodCatridgeClassName = `${cx(
                'lg8',
                'xl8',
                'prodCartridgeWrapper',
                'blockWithCart'
            )} ${dt(['sm:!p-0', '!block'])}`;
        }

        return (
            <>
                <div
                    className={`${prodCatridgeClassName} ${dt([
                        'p-0',
                        'bg-white',
                        'sm:!mx-0',
                        'sm:!px-6',
                        'sm:!mb-0',
                    ])}`}
                >
                    <CertonaZone
                        page={productCartridgeAttribute.pagetype}
                        fromCart
                        slotDetails={{
                            pageType: `${productCartridgeAttribute.slotTypeOne}`,
                            attributes: {
                                recommendations: true,
                                ...certonaAttributes,
                            },
                            loader: 'certona',
                            slotId: productCartridgeAttribute.slotIdTwo,
                        }}
                        schemasToRender={[productCartridgeAttribute.slotIdTwo]}
                        disableLazyLoad
                        forceRefresh
                        refreshCertona
                    />
                </div>
                <div
                    className={`${prodCatridgeClassName} ${dt([
                        'bg-white',
                        'sm:!mx-0',
                        'sm:!px-6',
                        'sm:!mb-0',
                    ])}`}
                >
                    <CertonaZone
                        page={productCartridgeAttribute.pagetype}
                        fromCart
                        slotDetails={{
                            pageType: `${productCartridgeAttribute.slotTypeTwo}`,
                            attributes: {
                                recommendations: true,
                                ...certonaAttributes,
                            },
                            loader: 'certona',
                            slotId: productCartridgeAttribute.slotIdOne,
                        }}
                        schemasToRender={[productCartridgeAttribute.slotIdOne]}
                        disableLazyLoad
                        forceRefresh
                        refreshCertona
                    />
                </div>
            </>
        );
    }

    renderSlidePanel = () => {
        return (
            <section>
                <SerialCodeInputModal pageInfo="cart" />
                <ShowRewardsPanel pageInfo="cart" />
                <CouponsPanel pageInfo="cart" panelTitle="Coupons" />
            </section>
        );
    };

    render() {
        const {
            loadEmptyCart,
            cartDetails,
            deviceType,
            isSessionTimedOut,
            noPartsAndService,
            showBlurBG,
            orderInfo,
            location,
        } = this.props;
        const disabledCartSSR = get(this.props.headers, 'cookies.disabledCartSSR');
        const ctaBtns = [
            {
                title: cartPageMsg.OK_BTN_LABLE,
                buttonType: 'Primary',
                automationId: 'partsserviceerror',
                size: 'Md',
            },
        ];

        return (
            <Layout
                showBlurBG={showBlurBG}
                layoutArticleClass={cx('cartArticleBlock')}
                checkoutProps={{
                    findStores: { selectActionCallback: this.props.actions.getCartDetails },
                }}
            >
                <Helmet title={PAGE_TITLES_CART} />
                <Canonincalize urlLocation={location.pathname} />
                {noPartsAndService && (
                    <ModalBox
                        deviceType={deviceType}
                        showModal={noPartsAndService}
                        modalTheme={cx('modalStyle')}
                        defaultHeader
                        title={cartPageMsg.upsellErrorMsg}
                        ctaBtns={ctaBtns}
                    />
                )}
                <GenericOopsMessage />
                <section
                    className={dt([
                        'h-full',
                        'relative',
                        !deviceType.isDesktop && 'cursor-pointer',
                        !loadEmptyCart && 'min-h-[900px]',
                        'tailwindGrid',
                    ])}
                    data-automation-id="at-cart-page-block"
                    style={{ 'min-height': `${this.state.mainContainerHeightOverride}px` }}
                    ref={this.pageBlockRef}
                >
                    <section>
                        {isEmpty(cartDetails) && !loadEmptyCart && <CartItemPreShellLoader />}

                        <ATCInterstitialContextProvider>
                            <span>
                                {disabledCartSSR === 'true' ? (
                                    <CartPageWrapper
                                        stickyParentBlock={this.pageBlockRef}
                                        orderSummaryHeight={this.evaluateMainContainerHeight}
                                        mainContainerHeightOverride={
                                            this.state.mainContainerHeightOverride
                                        }
                                    />
                                ) : (
                                    <CartPageWrapper
                                        mountOnServer
                                        stickyParentBlock={this.pageBlockRef}
                                        orderSummaryHeight={this.evaluateMainContainerHeight}
                                        mainContainerHeightOverride={
                                            this.state.mainContainerHeightOverride
                                        }
                                    />
                                )}
                            </span>
                        </ATCInterstitialContextProvider>
                    </section>
                    {loadEmptyCart && (
                        <>
                            <div className={dt(['mx-6'])}>
                                <SavedItemsList loadEmptyCart={loadEmptyCart} />
                            </div>
                            {this.renderProductCartridge()}
                            {!__SERVER__ && (!isEmpty(cartDetails) || loadEmptyCart) && (
                                <PageBanners
                                    googleBVAdsId={GOOGLE_ADS_CART_PAGE_BOTTOM_LEFT}
                                    isJcpCardInOrder={
                                        (orderInfo && orderInfo.isJcpCardInOrder) || false
                                    }
                                    customClass={loadEmptyCart ? 'lg12' : 'lg8'}
                                />
                            )}
                        </>
                    )}
                    {isSessionTimedOut && <SessionTimeoutModal isShowModal={isSessionTimedOut} />}
                </section>
                {!__SERVER__ && !isEmpty(cartDetails) && this.renderSlidePanel()}
            </Layout>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        certonaAttributes,
        cartDetails,
        loadEmptyCart,
        analyticsClickEvent,
        sflActionStatus,
        selectedStore,
        session,
        tokenInfo,
        orderInfo,
        orderTotals,
    } = state;
    const deviceType = get(state, 'context.deviceType');
    const featureFlags = get(state, 'context.featureFlags');
    const preferences = get(state, 'context.preferences');
    const headers = get(state, 'context.headers');
    const isNative = get(state, 'context.isNative');
    return {
        certonaAttributes,
        cartDetails,
        loadEmptyCart,
        analyticsClickEvent,
        deviceType,
        sflActionStatus,
        selectedStore,
        isSessionTimedOut: session.isSessionTimedOut,
        tokenInfo,
        featureFlags,
        preferences,
        orderInfo,
        orderTotals,
        headers,
        isNative,
        showBlurBG:
            get(state, 'applePayOrderInfo.showApplePaySheet', false) ||
            get(state, 'SingleClickOrderInfo.showPanel', false),
    };
};

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            updateAnalyticsClickAction,
            ...CheckoutAnalyticsAction,
            ...orderActions,
            ...splunkLogsActions,
            ...itemActions,
            ...cartDetailsAction,
            ...nativeAppAction,
        },
        dispatch
    ),
});

export default withBoundaryError(connect(mapStateToProps, mapDispatchToProps)(CartPage), section);
